import { textWithHTML, percentage } from 'Data/format.js'

export function getText(credit_fee_percent) {
  return textWithHTML(
    `A <b>fee of ${percentage(
      credit_fee_percent
    )}</b> will be applied to all credit card payments. This fee will not apply to debit card or ACH payments. I acknowledge that enabling this fee requires notifying all responsible parties, including those with existing payments who may not have agreed to this fee in their original terms.`
  )
}
